import { PartialRecord } from "@base/util/TypeUtil";
import { EdgeName } from "@biz/definitions/SunSailDefinitions";
import { getEdgeName } from "@biz/definitions/SunSailDefinitions.util";
import { NetPointName, NetShapeType } from "@biz/items/net/NetDefinitions";
import { SailShapeType } from "@biz/sc/sunSail/SailPreconfig";

export class NetShapeLogic {
  static getEdgeNameForCornerIndex(shape: NetShapeType, iCorner: number, sorted?: boolean): EdgeName {
    const edgeName = getEdgeName(iCorner, (iCorner + 1) % NetShapeLogic.getPointCount(shape), sorted);
    return edgeName
  }

  static getEdgeNamesForCornerIndex(shape: NetShapeType, iCorner: number, sorted?: boolean): {
    prev: EdgeName;
    next: EdgeName;
  } {
    const pointCount = NetShapeLogic.getPointCount(shape);

    return {
      prev: getEdgeName((iCorner + pointCount - 1) % pointCount, iCorner, sorted),
      next: getEdgeName(iCorner, (iCorner + 1) % pointCount, sorted),
    }
  }

  // static calcStartCornerIndexForEdgeName(shape: NetShapeType, edgeName: EdgeName,): number {
  //   const pointCount = NetShapeLogic.getPointCount(shape);
  //   const indices = getNetEdgeIndices(edgeName);
  //   const minIndex = Math.min(indices[0], indices[1]);
  //   const maxIndex = Math.max(indices[0], indices[1]);
  //   const iCorner = minIndex === 0 && maxIndex === pointCount - 1 ? maxIndex : minIndex;
  //   return iCorner;
  // }

  static getEdgesForShape(inputShapeType: NetShapeType | undefined): EdgeName[] {
    switch (inputShapeType || "rectangle") {
      case "triangle": return ["ab", "bc", "ac"];
      case "quad":
      case "rectangle": return ["ab", "bc", "cd", "ad"];
    }
    return [];
  }

  static getPointNamesForShape(inputShapeType: NetShapeType): NetPointName[] {
    switch (inputShapeType) {
      case "triangle": return ["a", "b", "c"];
      case "quad": return ["a", "b", "c", "d"];
      case "rectangle": return ["a", "b", "c", "d"];
    }
    return [];
  }

  static getPointCount(shape: NetShapeType): number {
    switch (shape) {
      case "triangle": return 3;
      case "quad":
      case "rectangle": return 4;
    }
    return 0
  }

  static getPrevAndNextEdge(edgeName: EdgeName, inputShapeType: NetShapeType) {
    const edges = NetShapeLogic.getEdgesForShape(inputShapeType);
    const index = edges.indexOf(edgeName);
    const next = edges[(index + 1) % edges.length]
    const prev = edges[(index + edges.length - 1) % edges.length]
    return { next, prev };
  }

  // static getInputShapeType(inputShapeType: NetShapeType | undefined): NetShapeType {
  //   return (inputShapeType || "triangle");
  // }

  static createRectangleDimensions(l: number, w: number): PartialRecord<EdgeName, number> {
    return { ab: l, bc: w, cd: l, ad: w, ac: Math.sqrt(l * l + w * w) };
  }

  static getInitialDimensions(shapeType?: NetShapeType): PartialRecord<EdgeName, number> {
    switch (shapeType) {
      case "triangle":
        return { ab: 3, bc: 3, ac: 3 };
      case "quad":
        return NetShapeLogic.createRectangleDimensions(4, 3);
      case "rectangle":
        return NetShapeLogic.createRectangleDimensions(4, 3);
    }
    return {};
  }

  static getInputShapeType(inputShapeType: SailShapeType | undefined): SailShapeType {
    return (inputShapeType || "triangle");
  }
}